// 用户账户详情
export const URI_USER_ACCOUNT = '/s1/user.account'
// 微信提现
export const URI_WECHAT_WITHDRAW = '/s1/user.withdraw.wechat'
// 我的队员 - 日期
export const URI_MEMBER_DATE = '/s1/user.members_by_date'
// 我的队员 - 收入
export const URI_MEMBER_INCOME = '/s1/user.members_by_income'
// 我的提成
export const URI_MY_COMMISION = '/s1/user.teamReward'
// 更多提成
export const URI_MORE_COMMISSION = '/s1/user.teamReward_by_tab'
// 团队奖励
export const URI_TEAM_REWARD = '/s1/team.draw_reward'
